export default {"src":"/_next/static/media/skar-audio-logo-black.144d46db.svg","height":629,"width":2006,"blurWidth":0,"blurHeight":0};